import { configService } from "../index";
import { BaseRequests } from "./BaseRequestsV2";
import { BaseRequestsInterface } from "./BaseRequestsV2";
import { ExperienceAvailability } from '@/models/experience-availability';

export default {
  ...BaseRequests(
    () => configService.experienceAvailability,
    "experienceAvailability",
    () => new ExperienceAvailability()
  )
} as BaseRequestsInterface;
